import { GitCommitVertical } from "lucide-react";

const STEPS = [
  { key: "step-mqls", label: "MQLs Entered", value: 487 },
  { key: "step-email", label: "Email Sequence Active", value: 341 },
  { key: "step-sms", label: "SMS Re-engaged", value: 198 },
  { key: "step-voice", label: "Voice Follow-Up Attempted", value: 89 },
  { key: "step-demo", label: "Demos Booked", value: 31 },
  { key: "step-won", label: "Closed / Won", value: 8 },
];

export default function ConversionFunnel() {
  const max = STEPS[0].value;

  return (
    <article data-testid="conversion-funnel-card" className="card-glass p-6 h-full">
      <header className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2.5">
          <div
            className="flex items-center justify-center rounded-md"
            style={{ width: 28, height: 28, background: "rgba(14, 165, 233, 0.10)", border: "1px solid rgba(14, 165, 233, 0.25)" }}
          >
            <GitCommitVertical size={14} color="#0EA5E9" />
          </div>
          <div>
            <h2
              style={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 700,
                fontSize: 15,
                color: "var(--text-primary)",
              }}
            >
              Conversion Funnel
            </h2>
            <div
              style={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: 10,
                letterSpacing: "0.12em",
                color: "var(--text-muted)",
                textTransform: "uppercase",
              }}
            >
              This month · MQL → Won
            </div>
          </div>
        </div>
        <div
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: 11,
            padding: "3px 8px",
            borderRadius: 4,
            color: "#00C2A8",
            background: "rgba(0, 194, 168, 0.08)",
            border: "1px solid rgba(0, 194, 168, 0.20)",
          }}
        >
          1.6% MQL→Won
        </div>
      </header>

      <div>
        {STEPS.map((s, i) => {
          const pct = Math.round((s.value / max) * 100);
          const width = 55 + (pct / 100) * 45; // 55% min → 100%
          const isLast = i === STEPS.length - 1;
          return (
            <div key={s.key} data-testid={s.key}>
              <div
                className="funnel-step enter-up"
                style={{
                  width: `${width}%`,
                  animationDelay: `${i * 80}ms`,
                }}
              >
                <div className="min-w-0 pr-3">
                  <div
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontSize: 12.5,
                      fontWeight: 500,
                      color: "var(--text-primary)",
                    }}
                  >
                    {s.label}
                  </div>
                  <div className="mt-1.5 progress-track" style={{ width: 130 }}>
                    <div className="progress-fill" style={{ width: `${pct}%` }} />
                  </div>
                </div>
                <div className="text-right">
                  <div
                    style={{
                      fontFamily: "'JetBrains Mono', monospace",
                      fontWeight: 600,
                      fontSize: 20,
                      color: "var(--text-primary)",
                      letterSpacing: "-0.01em",
                    }}
                  >
                    {s.value}
                  </div>
                  <div
                    style={{
                      fontFamily: "'JetBrains Mono', monospace",
                      fontSize: 10,
                      color: "var(--text-muted)",
                    }}
                  >
                    {pct}%
                  </div>
                </div>
              </div>
              {!isLast && <div className="funnel-connector" style={{ width: `${width}%` }} />}
            </div>
          );
        })}
      </div>
    </article>
  );
}
